import * as React from 'react';
import { FunctionComponent, useEffect } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import Typography from '@mui/material/Typography';
import styles from './styles';
import { Spacing } from '../../../Layout';
import { useSelector } from 'react-redux';
import {
    getReferralReasonTypesByCode,
    getSubmissionDetails,
    getUwReview,
} from '../../../../application/redux/selectors';
import { getLocationReferralTriggerByReason } from '../../../../application/redux/selectors/submissionReferralMetadata';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { useActions } from '../../../../hooks/useActions';
import * as Actions from '../../../../application/redux/actions';
import { DefaultTheme, withStyles, WithStyles, withTheme, WithTheme } from '@mui/styles';

interface Props {
    locationId?: number;
}

const ActivatedTriggerTable: FunctionComponent<Props & WithStyles<typeof styles> & WithTheme> = (props) => {
    const { locationId, classes, theme } = { ...props };

    const reasonByCode = useSelector(getReferralReasonTypesByCode);
    const locationTriggers = useSelector(
        getLocationReferralTriggerByReason(locationId ? Number(locationId) : undefined)
    );
    const uwReview = useSelector(getUwReview);
    const submission = useSelector(getSubmissionDetails);
    const { fetchReferralMetaData } = useActions(Actions);

    useEffect(() => {
        fetchReferralMetaData(submission.id);
    }, [uwReview]);

    const buildTriggerTable = () => (
        <>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '50px' }} />
                        <TableCell style={{ width: '250px' }}>Trigger</TableCell>
                        {!locationId && (
                            <>
                                <TableCell>Locations</TableCell>
                            </>
                        )}
                        {locationId && (
                            <>
                                <TableCell />
                                <TableCell align={'right'}>Threshold Value</TableCell>
                                <TableCell align={'right'}>Actual Value</TableCell>
                            </>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {locationTriggers &&
                        Object.keys(locationTriggers).map((reasonCode) => (
                            <TableRow key={reasonCode}>
                                <TableCell>
                                    <ReportProblemOutlinedIcon
                                        style={{
                                            color: locationTriggers[reasonCode][0].doRestrictQuote
                                                ? theme.palette.error.main
                                                : theme.palette.warning.main,
                                        }}
                                    />
                                </TableCell>
                                <TableCell>{reasonByCode[reasonCode].displayValue}</TableCell>
                                {!locationId && (
                                    <>
                                        <TableCell>
                                            {locationTriggers[reasonCode].map((lt) => lt.locationName).join(',')}
                                        </TableCell>
                                    </>
                                )}
                                {locationId && (
                                    <>
                                        <TableCell></TableCell>
                                        <TableCell align={'right'}>
                                            {locationTriggers[reasonCode][0].formattedDefinedThreshold}
                                        </TableCell>
                                        <TableCell align={'right'}>
                                            {locationTriggers[reasonCode][0].formattedActualValue}
                                        </TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            {(!locationTriggers || Object.keys(locationTriggers).length === 0) && (
                <>
                    <Spacing height={'12px'} />
                    <Typography>{`Currently there are no Activated Triggers`}</Typography>
                </>
            )}
        </>
    );

    return <>{buildTriggerTable()}</>;
};

export default withStyles(styles)(withTheme<DefaultTheme, typeof ActivatedTriggerTable>(ActivatedTriggerTable));
